export default __webpack_public_path__ + "static/media/funnel.667f8929.svg";